import React from 'react';
import {Dialog, DialogActions, DialogContent, Button, TextField, Fab, FormControl, InputLabel, Select, MenuItem, Input, Divider} from '@material-ui/core'
import ListaRaspunsuri from './ListaRaspunsuri'
import RaspunsDialog from './RaspunsDialog'
import WsC from './providers/WsC'
import PropTypes from 'prop-types'

export default class DialogRaspunsuri extends React.Component {
    constructor(props) {
      super(props);
       this.state = { 
                    listRaspunsuri:this.props.raspunsuri ,
                    isOpenRaspuns:false,
                    isOpenRaspunsUpdate:false,
                    strNume:'',
                    strPuncte:'',
                    strRaspunsNume:'',
                    objRaspunsInfo:{}
                }
    }

     componentDidMount(){
     //   console.log('this.props.raspunsuri :', this.props.raspunsuri);
    }


    
        


    insertRaspuns = async()=>{

      //  console.warn('get raspunsurui=---------------- :', );

            let ws = new WsC();


            let raspuns =  {label:this.state.strRaspunsNume, id_intrebare:this.props.objIntrebareInfo.id, puncte:this.state.strPuncte}
          //  console.log('this.props.intrebareInfo :', this.props.objIntrebareInfo);
    
            let insertRaspuns = await ws.insert('chestionare_intrebari_optiuni_raspuns', raspuns)
    
    
            if(insertRaspuns.Succes){
    
                let listCloneRaspuns = [...this.state.listRaspunsuri]
                raspuns.id = insertRaspuns.Content[0].id
                raspuns.inactiv = 0
                raspuns.img_src=null
    
                listCloneRaspuns.push(raspuns)
    
                this.setState({listRaspunsuri:listCloneRaspuns,
                                strRaspunsNume:'',
                                 strPuncte:'',
                                isOpenRaspuns:false}, ()=>{
                                    this.props.getRaspunsuri()
                                })
                
            }
     
         
    }

    goToRaspuns = (r) =>{
       // console.log('r :', r);

        this.setState({
                strRaspunsNume:r.label,
                strPuncte:r.puncte,
                objRaspunsInfo:r,
                isOpenRaspunsUpdate:true,
                
        })
    }

    getRaspunsuri = async () => {

        let ws = new WsC();



       // console.warn('get raspunsurui=---------------- :', );
       // console.log('this.props.objIntrebareInfo.id :', this.props.objIntrebareInfo.id);
        let getRaspunsuri = await ws.customSelect('select * from chestionare_intrebari_optiuni_raspuns where isnull(inactiv,0) != 1 and id_intrebare = @p1', {
            p1: this.props.objIntrebareInfo.id
        })




       // console.warn('getRaspunsuri :', getRaspunsuri);
        if (getRaspunsuri.Succes) {
            this.setState({ listRaspunsuri: getRaspunsuri.Content },()=>{
                
                this.props.getRaspunsuri()
                this.props.getChestionar()
            })
      
        }

    }

    updateRaspuns = async()=>{
       

            let ws = new WsC();

            let updateR = await ws.update('chestionare_intrebari_optiuni_raspuns', {label:this.state.strRaspunsNume, puncte:this.state.strPuncte},{id:this.state.objRaspunsInfo.id})
    
            if(updateR.Succes){
                let listRaspunsuri = [...this.state.listRaspunsuri]
    
                let idx = listRaspunsuri.findIndex(r => r.id === this.state.objRaspunsInfo.id)
    
                listRaspunsuri[idx].label = this.state.strRaspunsNume
    
                this.setState({listRaspunsuri:listRaspunsuri,
                                strRaspunsNume:'',
                            isOpenRaspunsUpdate:false},()=>{
                                this.getRaspunsuri()
                            })
            }
      

      
       
        
    }

    deleteRaspuns=async(r)=>{
        
            let ws = new WsC()

            let deleteRaspuns = await ws.update('chestionare_intrebari_optiuni_raspuns', {inactiv:1}, {id:r.id})
    
            if(deleteRaspuns.Succes){
                let listCloneRaspunsuri = [...this.state.listRaspunsuri]
    
                let idx = listCloneRaspunsuri.findIndex(cr => cr.id === r.id)
    
                listCloneRaspunsuri.splice(idx,1)
    
                this.setState({listRaspunsuri:listCloneRaspunsuri},()=>{
                    this.props.getRaspunsuri()
                })
            }
      


        
    }


    salveaza= ()=>{

       

         
          
    
                this.props.updateIntrebare({intrebare:this.props.nume, tip: this.props.objIntrebareInfo.tip},{id:this.props.objIntrebareInfo.id})
         

      

       
    }

    openTrue=()=>{
        this.setState({listRaspunsuri:this.props.raspunsuri})
    }

    addRaspuns = () =>{
        if(this.props.objIntrebareInfo.tip.includes('img')){
            this.insertRaspuns()
        }else{
            this.setState({ isOpenRaspuns: true })
        }
    }
   
     render() { 
       return (
          <div>
               <Dialog 
                 className="insertDialog"
                disableEscapeKeyDown
                fullWidth={true}
                maxWidth={'md'}
                 open={this.props.open}
                 onClose={this.props.dialogClose}>
                 <DialogActions >
                 <Fab onClick={this.props.dialogClose} className="chestionare-anuleaza-button">
                            <i className='material-icons textPrimary iconFontSize'>close</i>
                        </Fab>
                 </DialogActions>
                        <DialogContent style={{textAlign:'center', overflow:'hidden'}}>
                            <TextField label='Intrebare'
                                    autoFocus
                                    multiline
                                     value={this.props.nume } 
                                    onChange={this.props.numeChange} 
                                    className='inputFocus'  style={{width:'90%'}}/>
                               
                        </DialogContent>

                           <DialogContent style={{textAlign:'center'}}>
                        <FormControl className='inputFocus' style={{ width: '90%', marginTop: 16 }}>
                                            <InputLabel htmlFor="beneficiari">Tip Intrebare</InputLabel>
                                            <Select
                                                label=""
                                                value={this.props.objIntrebareInfo.tip || ''}
                                                onChange={this.props.tipChange}
                                                input={<Input id="beneficiari" />}>


                                              {  this.props.tipuriIntrebari.map((s, idx) => {
                                                    return <MenuItem value={s.id} key={idx}  > {s.nume}</MenuItem>

                                                })
                                            }
                                            </Select>
                                        </FormControl>
                                    
                        </DialogContent>
                       

                      {this.props.objIntrebareInfo.tip !== 'text' &&  
                        <DialogContent style={{textAlign:'center'}}>
                            <ListaRaspunsuri
                                listaRaspunsuri={this.state.listRaspunsuri}
                                goToRaspuns={this.goToRaspuns}
                                objIntrebareInfo={this.props.objIntrebareInfo}
                                openRaspuns={this.addRaspuns}
                                deleteRaspuns={this.deleteRaspuns}
                                />
                      <Divider className="crm-divider" />
                        </DialogContent>
                      }
                       

                        <DialogActions className="chestionare-dialog-bottom-buttons">
                          
                            <Button  variant="contained" onClick={this.salveaza} className='chestionare-main-button'>
                                      Salveaza
                            </Button>

                              <Button  variant="contained" onClick={this.props.stergeIntrebare} className='chestionare-delete-button'>
                                      Sterge
                            </Button>
                            
                         
                        </DialogActions>
                        
                 </Dialog>

                 <RaspunsDialog
                    open={this.state.isOpenRaspuns}
                    dialogClose={() => { this.setState({ isOpenRaspuns: false, strRaspunsNume: '', strPuncte: '' }) }}
                    nume={this.state.strRaspunsNume}
                    numeChange={(ev) => { this.setState({ strRaspunsNume: ev.target.value }) }}
                    puncte={this.state.strPuncte}
                    puncteChange={(ev) => { this.setState({ strPuncte: ev.target.value }) }}
                    insertUpdate={this.insertRaspuns}
                    getRaspunsuri={this.getRaspunsuri}
                    scop='adauga'
                    tipRaspuns={this.props.objIntrebareInfo.tip}
                    raspuns={this.state.objRaspunsInfo} />

                <RaspunsDialog
                    open={this.state.isOpenRaspunsUpdate}
                    dialogClose={() => { this.setState({ isOpenRaspunsUpdate: false, strRaspunsNume: '', strPuncte: '' }) }}
                    nume={this.state.strRaspunsNume}
                    numeChange={(ev) => { this.setState({ strRaspunsNume: ev.target.value }) }}
                    puncte={this.state.strPuncte}
                    puncteChange={(ev) => { this.setState({ strPuncte: ev.target.value }) }}
                    insertUpdate={this.updateRaspuns}
                    getRaspunsuri={this.getRaspunsuri}
                    tipRaspuns={this.props.objIntrebareInfo.tip}
                    raspuns={this.state.objRaspunsInfo}
                    scop='editeaza' />
         </div>
        );
       }
}


DialogRaspunsuri.propType = {
    raspunsuri:PropTypes.array,
    intrebareInfo:PropTypes.object,
    nume:PropTypes.string,
    numeChange:PropTypes.func,
    updateIntrebare:PropTypes.func,
    open:PropTypes.bool,
    dialogClose:PropTypes.func,
    listRaspunsuri:PropTypes.array,
    stergeIntrebare:PropTypes.func

}



// import React from 'react';
// import {Dialog, DialogActions, DialogContent, Button, TextField, Switch, Fab, FormControl, InputLabel, Select, MenuItem, Input, Divider} from '@material-ui/core'
// import ListaRaspunsuri from '../../commons/lists/ListaRaspunsuri'
// import RaspunsDialog from './RaspunsDialog'
// import WsC from '../../providers/WsC';
// import PropTypes from 'prop-types'

// export default class DialogRaspunsuri extends React.Component {
//     constructor(props) {
//       super(props);
//        this.state = { 
//                     listRaspunsuri:this.props.raspunsuri ,
//                     isOpenRaspuns:false,
//                     isOpenRaspunsUpdate:false,
//                     strNume:'',
//                     strPuncte:'',
//                     strRaspunsNume:'',
//                     objRaspunsInfo:{}
//                 }
//     }

//      componentDidMount(){
//         console.log('this.props.raspunsuri :', this.props.raspunsuri);
//     }


    
        


//     insertRaspuns = async()=>{

//         let ws = new WsC();


//         let raspuns =  {label:this.state.strRaspunsNume, id_intrebare:this.props.intrebareInfo.id, puncte:this.state.strPuncte}
//         console.log('this.props.intrebareInfo :', this.props.intrebareInfo);

//         let insertRaspuns = await ws.insert('chestionare_intrebari_optiuni_raspuns', raspuns)


//         if(insertRaspuns.Succes){

//             let listCloneRaspuns = [...this.state.listRaspunsuri]
//             raspuns.id = insertRaspuns.Content[0].id
//             raspuns.inactiv = 0

//             listCloneRaspuns.push(raspuns)

//             this.setState({listRaspunsuri:listCloneRaspuns,
//                             strRaspunsNume:'',
//                              strPuncte:'',
//                             isOpenRaspuns:false})
            
//         }
//     }

//     goToRaspuns = (r) =>{
//         console.log('r :', r);

//         this.setState({
//                 strRaspunsNume:r.label,
//                 strPuncte:r.puncte,
//                 objRaspunsInfo:r,
//                 isOpenRaspunsUpdate:true,
                
//         })
//     }

//     updateRaspuns = async()=>{
//         let ws = new WsC();


//         let updateR = await ws.update('chestionare_intrebari_optiuni_raspuns', {label:this.state.strRaspunsNume, puncte:this.state.strPuncte},{id:this.state.objRaspunsInfo.id})

//         if(updateR.Succes){
//             let listRaspunsuri = [...this.state.listRaspunsuri]

//             let idx = listRaspunsuri.findIndex(r => r.id === this.state.objRaspunsInfo.id)

//             listRaspunsuri[idx].label = this.state.strRaspunsNume

//             this.setState({listRaspunsuri:listRaspunsuri,
//                             strRaspunsNume:'',
//                         isOpenRaspunsUpdate:false})
//         }
//     }

//     deleteRaspuns=async(r)=>{
//         console.log('raspuns :', r);


//         let ws = new WsC()

//         let deleteRaspuns = await ws.update('chestionare_intrebari_optiuni_raspuns', {inactiv:1}, {id:r.id})

//         if(deleteRaspuns.Succes){
//             let listCloneRaspunsuri = [...this.state.listRaspunsuri]

//             let idx = listCloneRaspunsuri.findIndex(cr => cr.id === r.id)

//             listCloneRaspunsuri.splice(idx,1)

//             this.setState({listRaspunsuri:listCloneRaspunsuri})
//         }
//     }


//     salveaza= async()=>{
//         let ws = new WsC();


//         let updateIntrebare = await ws.update('chestionare_intrebari', {intrebare:this.props.nume},{id:this.props.intrebareInfo.id})

//         console.log('updateIntrebare :', updateIntrebare);
//         if(updateIntrebare.Succes){
//             this.props.updateIntrebare()
//         }
//     }

//     openTrue=()=>{
//         this.setState({listRaspunsuri:this.props.raspunsuri})
//     }
   
//      render() { 
//        return (
//           <div>
//                <Dialog 
//                  className="insertDialog"
//                 disableBackdropClick
//                 disableEscapeKeyDown
//                 fullWidth={true}
//                 maxWidth={'sm'}
//                  open={this.props.open}
//                  onClose={this.props.dialogClose}>
//                  <DialogActions >
//                  <Fab  onClick={this.props.dialogClose} className="chestionare-anuleaza-button">
//                                       <i className='material-icons chestionare-anuleaza-button-icon'>close</i>
//                             </Fab>
//                  </DialogActions>
//                         <DialogContent style={{textAlign:'center', overflow:'hidden'}}>
//                             <TextField label='Intrebare'
//                                     autoFocus
//                                     multiline
//                                      value={this.props.nume } 
//                                     onChange={this.props.numeChange} 
//                                     className='inputFocus' />
                               
//                         </DialogContent>

//                       {this.props.intrebareInfo.tip !== 'text' &&  
//                         <DialogContent style={{textAlign:'center'}}>
//                             <ListaRaspunsuri
//                                 listaRaspunsuri={this.state.listRaspunsuri}
//                                 goToRaspuns={this.goToRaspuns}
//                                 openRaspuns={()=>{this.setState({isOpenRaspuns:true})}}
//                                 deleteRaspuns={this.deleteRaspuns}
//                                 />
//                       <Divider className="crm-divider" />
//                         </DialogContent>
//                       }
                       

//                         <DialogActions className="chestionare-dialog-bottom-buttons">
                          
//                             <Button  variant="contained" onClick={this.salveaza} className='chestionare-main-button'>
//                                       Salveaza
//                             </Button>

//                               <Button  variant="contained" onClick={this.props.stergeIntrebare} className='chestionare-delete-button'>
//                                       Sterge
//                             </Button>
                            
                         
//                         </DialogActions>
                        
//                  </Dialog>

//                  <RaspunsDialog 
//                     open={this.state.isOpenRaspuns}
//                     dialogClose={()=>{this.setState({isOpenRaspuns:false, strRaspunsNume:'', strPuncte:''})}}
//                     nume={this.state.strRaspunsNume}
//                     numeChange={(ev)=>{this.setState({strRaspunsNume:ev.target.value})}}
//                     puncte={this.state.strPuncte}
//                     puncteChange={(ev)=>{this.setState({strPuncte:ev.target.value})}}
//                     insertUpdate={this.insertRaspuns}
//                     scop='adauga'/>

//                     <RaspunsDialog 
//                     open={this.state.isOpenRaspunsUpdate}
//                     dialogClose={()=>{this.setState({isOpenRaspunsUpdate:false, strRaspunsNume:'', strPuncte:''})}}
//                     nume={this.state.strRaspunsNume}
//                     numeChange={(ev)=>{this.setState({strRaspunsNume:ev.target.value})}}
//                     puncte={this.state.strPuncte}
//                     puncteChange={(ev)=>{this.setState({strPuncte:ev.target.value})}}
//                     insertUpdate={this.updateRaspuns}
//                     scop='editeaza'/>
//          </div>
//         );
//        }
// }


// DialogRaspunsuri.propType = {
//     raspunsuri:PropTypes.array,
//     intrebareInfo:PropTypes.object,
//     nume:PropTypes.string,
//     numeChange:PropTypes.func,
//     updateIntrebare:PropTypes.func,
//     open:PropTypes.bool,
//     dialogClose:PropTypes.func,
//     listRaspunsuri:PropTypes.array,
//     stergeIntrebare:PropTypes.func

// }